import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CancelButton, DBDateFieldDiagOnset } from '_components';
import { patientActions } from '_actions';
import styles from './Common.module.css'

class PatientCareCenterNoteChargesDiagRow extends React.Component {

    removeDiag() {
        this.props.removeDiag(this.props.epno, this.props.diag.diag, this.props.diag.type, this.props.diag.id);
    }


    render() {
        return (
            <div className={styles.diag_row}>
                <span className={styles.remove_button}>
                    <CancelButton size='extra-small' onClick={() => this.removeDiag()} />
                </span>
                <span className={styles.diag_desc} title={this.props.diag.diag + ' - ' + this.props.diag.desc}>
                    {this.props.diag.diag + ' - ' + this.props.diag.desc}
                </span>
                {this.props.requireOnsets &&
                    <span className={styles.onset}>
                        <DBDateFieldDiagOnset id={this.props.diag.id} maxDate={new Date()} />
                    </span>
                }
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        removeDiag: bindActionCreators(patientActions.removeDiag, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let requireOnsets = state.entities.admissions[epno].requireDiagOnsets;
    let diag = state.entities.diagnosis[ownprops.id];

    return {
        noteId,
        epno,
        requireOnsets,
        diag
    };
}

const connectedPatientCareCenterNoteChargesDiagRow = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteChargesDiagRow);
export { connectedPatientCareCenterNoteChargesDiagRow as PatientCareCenterNoteChargesDiagRow };

